<div class="coso-chat-shell flex h-full min-h-0 flex-col px-4 pb-2 coso-bg" [class.has-selected-chat]="!!selectedChat">
    <div class="flex w-full flex-row items-center justify-between pb-4">
        <div class="flex min-w-0 items-center gap-3 pt-1">
            <img src="assets/COSO-avatar-light-64x64.png"
                 class="block shrink-0 dark:hidden"
                 height="48" width="48"
                 alt="Avatar" />
            <img src="assets/COSO-avatar-dark-64x64.png"
                 class="hidden shrink-0 dark:block"
                 height="48" width="48"
                 alt="Avatar" />
            <div class="min-w-0">
                <div class="truncate text-lg font-bold">{{ selectedChat?.chat_title || environment.COSO_NAME }}</div>
                <div class="truncate text-sm text-gray-500">{{ selectedChat ? getConfigHint(selectedChat) : 'Recent chats' }}</div>
            </div>
        </div>
        <div class="flex items-center gap-1 mt-1">
            <p-button id="create-chat-button" class="coso-chat-new-button" size="large" [rounded]="true" [text]="true" severity="secondary"
                      [loading]="creatingChat"
                      [disabled]="creatingChat"
                      (onClick)="openCreateChatOverlay($event)"
                      pTooltip="New chat" tooltipPosition="bottom" tooltipStyleClass="text-sm"
                      showDelay="1000">
                <ng-template #icon>
                    <span class="material-symbols-outlined">chat_add_on</span>
                </ng-template>
            </p-button>
          @if (selectedChat) {
              <p-button class="coso-chat-back-button" size="large" [rounded]="true" [text]="true"
                        severity="secondary"
                        [disabled]="liveActive()"
                        (click)="backToList()"
                        pTooltip="Chats list" tooltipPosition="bottom" tooltipStyleClass="text-sm"
                        showDelay="1000">
                  <ng-template #icon>
                      <span class="material-symbols-outlined mt-1 text-2xl!">forum</span>
                  </ng-template>
              </p-button>
          }
            @if (selectedChat) {
                @if (fullScreen) {
                    <p-button icon="pi pi-window-minimize" size="large" [rounded]="true" [text]="true" severity="secondary"
                              (click)="toggleFullScreen.emit()"
                              pTooltip="Minimize chat panel" tooltipPosition="bottom" tooltipStyleClass="text-sm"
                              showDelay="1000"></p-button>
                } @else {
                    <p-button icon="pi pi-ellipsis-v" size="large" [rounded]="true" [text]="true" severity="secondary"
                              (click)="chatActionsMenu.toggle($event)"
                              pTooltip="Chat actions" tooltipPosition="bottom" tooltipStyleClass="text-sm"
                              showDelay="1000"></p-button>
                    <p-menu #chatActionsMenu [model]="chatActionItems" [popup]="true" appendTo="body"/>
                    @if (!standalone) {
                        <p-button icon="pi pi-window-maximize" size="large" [rounded]="true" [text]="true"
                                  severity="secondary"
                                  (click)="toggleFullScreen.emit()"
                                  pTooltip="Maximize chat panel" tooltipPosition="bottom" tooltipStyleClass="text-sm"
                                  showDelay="1000"></p-button>
                    }
                }
            } @else {
                @if (fullScreen) {
                    <p-button icon="pi pi-window-minimize" size="large" [rounded]="true" [text]="true" severity="secondary"
                              (click)="toggleFullScreen.emit()"
                              pTooltip="Minimize chat panel" tooltipPosition="bottom" tooltipStyleClass="text-sm"
                              showDelay="1000"></p-button>
                } @else {
                    @if (!standalone) {
                        <p-button icon="pi pi-window-maximize" size="large" [rounded]="true" [text]="true"
                                  severity="secondary"
                                  (click)="toggleFullScreen.emit()"
                                  pTooltip="Maximize chat panel" tooltipPosition="bottom" tooltipStyleClass="text-sm"
                                  showDelay="1000"></p-button>
                    }
                }
            }
            @if (!standalone) {
                <p-button icon="pi pi-times" size="large" [rounded]="true" [text]="true" severity="secondary"
                          (click)="closeChat.emit()"
                          pTooltip="Close chat panel" tooltipPosition="bottom" tooltipStyleClass="text-sm"
                          showDelay="1000"></p-button>
            }
        </div>
    </div>

    <div class="coso-chat-body min-h-0 flex-1" [class.has-selected-chat]="!!selectedChat">
        <app-coso-chat-list
                class="coso-chat-list-pane min-h-0 flex-1"
                [chats]="chats"
                [allowedCosoConfigs]="allowedCosoConfigs"
                [selectedChat]="selectedChat"
                [loading]="loadingChats"
                [creating]="creatingChat"
                [deletingChatId]="deletingChatId"
                [renamingChatId]="renamingChatId"
                (createChat)="openCreateChatOverlay($event)"
                (selectChat)="openChat($event)"
                (deleteChat)="deleteChat($event)"
                (renameChat)="renameChat($event)">
        </app-coso-chat-list>
        @if (selectedChat) {
            <app-coso-chat-detail
                    class="coso-chat-detail-pane min-h-0 flex-1"
                    [selectedChat]="selectedChat"
                    (chatUpdated)="onChatUpdated($event)">
            </app-coso-chat-detail>
        } @else {
            <div class="coso-chat-empty-pane min-h-0 flex-1 items-center justify-center text-center text-gray-500">
                <div class="flex flex-col items-center gap-3">
                    <i class="pi pi-comments text-3xl"></i>
                    <div class="text-sm">Select or create a new chat.</div>
                </div>
            </div>
        }
    </div>
</div>

<p-popover #newChatPopover appendTo="body" styleClass="coso-chat-create-popover">
    <div class="flex flex-col gap-3 p-3">
        <div class="flex min-w-0 w-48 flex-col gap-2">
            <label for="new-chat-config" class="text-sm font-medium">Flow</label>

            @if (allowedCosoConfigs.length) {
                <p-select id="new-chat-config"
                          [(ngModel)]="newChatConfig"
                          [options]="allowedCosoConfigs"
                          optionLabel="flow"
                          size="small"
                          placeholder="Select a flow"
                          class="w-full"/>
            }
        </div>

        @if (!allowedCosoConfigs.length) {
            <div class="rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-500 dark:border-gray-700 dark:bg-gray-900/40">
                You don't have access to any flows.
            </div>
        }

        <div class="flex">
            <p-button label="Create" icon="pi pi-plus"
                      class="w-full"
                      styleClass="w-full"
                      [loading]="creatingChat"
                      [disabled]="!canCreateNewChat()"
                      (onClick)="createChat()"></p-button>
        </div>
    </div>
</p-popover>
